'use client'

import { ClockTimestampContext } from '@/components/utils/clock/ClockTimestampContext'
import { useInterval } from '@/hooks/browser/useInterval'
import { dayjs } from '@/lib/dayjs'
import { ReactNode, useState } from 'react'

type ClockContextProviderProps = {
  refreshRate: number
  children?: ReactNode
}

function ClockTimestampProvider({ refreshRate, children }: ClockContextProviderProps) {
  const [unixTimestampNow, setUnixTimestampNow] = useState(() => dayjs().valueOf())
  useInterval(() => setUnixTimestampNow(dayjs().valueOf()), refreshRate)
  return (
    <ClockTimestampContext.Provider value={unixTimestampNow}>
      {children}
    </ClockTimestampContext.Provider>
  )
}

export { ClockTimestampProvider }
